import React from 'react'
import Layout from '../components/Layout'
import Banner from '../components/Banner'
import SEO from '../components/Seo' 

export default function Page() {

    return (
        <>
            <SEO
                title=""
                description=""
            />
            <Layout>
                <div className="mainContainer">
                    <div className="container-fluid s2">
                        <div className="container">
                            <div className="row">
                                <h1 className="center">Disable Push Notifications (Alerts)</h1>
                                <div className="container center">
                                    <h2>Ready to Opt-Out of Our Alerts?</h2>
                                    <ol>
                                        <li><a href="#mobile-browser-video">Android</a></li>
                                        <li><a href="#mobile-app-video">Instantcheckmate App</a></li>
                                        <li><a href="#desktop-chrome-video">Chrome Desktop</a></li>
                                        <li><a href="#desktop-firefox-video">Firefox Desktop</a></li>
                                        <li><a href="#desktop-safari-video">Safari Desktop</a></li>
                                        <li><a href="#desktop-edge-video">Edge Desktop</a></li>
                                        <li><a href="#desktop-opera-video">Opera Desktop</a></li>
                                    </ol>
                                    <hr />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>Mobile - Browser (Android)</h3>
                                    <p>In order to disable push notifications on Mobile Devices follow the instructions below:</p>
                                    <ul>
                                        <li>1. On your Android device, go to Browser Settings &gt; Site Settings &gt; Notifications</li>
                                        <li>2. Select the site you want to unsubscribe from</li>
                                        <li>3. Under Permissions, click Notifications and change it to ‘Block’ or ‘Clear &amp; Reset’</li>
                                    </ul>
                                    <div id="mobile-browser-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/android-chrome-push-notifications.mp4" type="video/mp4" />
                                            Your browser does not support HTML5 video.
</video></div>
                                    <h3>Mobile - App (Android)</h3>
                                    <p>In order to disable push notifications on the InstantCheckmate app please follow the instructions below:</p>
                                    <ul>
                                        <li>1. On your Android device, tap Apps &gt; Settings &gt; More</li>
                                        <li>2. Tap Application manager &gt; Downloaded</li>
                                        <li>3. Tap on the InstantCheckmate app</li>
                                        <li>4. Select or clear the check box next to Show notifications to enable or disable push notifications</li>
                                    </ul>
                                    <div id="mobile-app-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/android-icm-push-notifications.mp4" type="video/mp4" />
                                            Your browser does not support HTML5 video.
</video></div>
                                    <h3>Desktop - Chrome</h3>
                                    <p>In order to disable push notifications on Chrome please follow the instructions below:</p>
                                    <ul>
                                        <li>1. Click the Chrome menu (three vertical dots in the upper right hand corner) &gt; Settings &gt; Click on “Show advanced settings”</li>
                                        <li>2. Under Privacy, click on “Content settings…”</li>
                                        <li>3. Scroll to Notifications and click “Manage exceptions…”</li>
                                        <li>4. Find the desired website → Select Block → Click Done</li>
                                    </ul>
                                    <div id="desktop-chrome-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/chrome-push-notifications.mp4" type="video/mp4" />
                                            Your browser does not support HTML5 video.
</video></div>
                                    <h3>Desktop - Firefox</h3>
                                    <p>In order to disable push notifications on Firefox please follow the instructions below:</p>
                                    <ul>
                                        <li>1. Go to the Firefox menu and select Preferences</li>
                                        <li>2. Select the Content panel and click the Choose… button under Notifications</li>
                                        <li>3. Select the site</li>
                                        <li>4. Click Remove Site</li>
                                    </ul>
                                    <div id="desktop-firefox-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/firefox-push-notifications.mp4" type="video/mp4" />
                                                    Your browser does not support HTML5 video.
</video></div>
                                    <h3>Desktop - Safari</h3>
                                    <p>In order to disable push notifications on Safari please follow the instructions below:</p>
                                    <ul>
                                        <li>1. Go to the Safari menu and select Preferences</li>
                                        <li>2. Click on the Notifications tab</li>
                                        <li>3. Find the desired website and click Deny</li>
                                    </ul>
                                    <div id="desktop-safari-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/safari-push-notifications.mp4" type="video/mp4" />
                                                        Your browser does not support HTML5 video.
</video></div>
                                    <h3>Desktop - Edge (Microsoft 10)</h3>
                                    <p>In order to disable push notifications on Edge please follow the instructions below:</p>
                                    <ul>
                                        <li>1. Click on the menu icon (three horizontal dots in the upper right-hand corner) &gt; Settings &gt; View advanced settings</li>
                                        <li>2. Under Notifications, click Manage</li>
                                        <li>3. Find the desired website and edit notification settings</li>
                                    </ul>
                                    <div id="desktop-edge-video" className="video-container"><video controls="controls" width="100%">
                                        <source src="/edge-push-notifications.mp4" type="video/mp4" />
                                                            Your browser does not support HTML5 video.
</video></div>
                                    <h3>Desktop - Opera (Linux)</h3>
                                    <p>In order to disable push notifications on Mobile Devices please follow the instructions below:</p>
                                    <ul>
                                        <li>1. Go to Opera &gt; Preferences (Mac)/Settings (Windows)</li>
                                        <li>2. Go to the Websites tab and scroll to the Notifications section</li>
                                        <li>3. Click on “Manage exceptions…”</li>
                                        <li>4. Find the desired website → Click the “X” next to Allow to remove it from the list</li>
                                        <li>5. Click Done</li>
                                    </ul>
                                    <div id="desktop-opera-video" className="video-container">
                                        <video controls="controls" width="100%">
                                            <source src="/opera-push-notifications.mp4" type="video/mp4" />
                                                                    Your browser does not support HTML5 video.
</video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Banner />
            </Layout>
        </>
    )
}





